// extracted by mini-css-extract-plugin
export default {"shape":"Shape_shape__vXET2","small":"Shape_small__mC+tS","circle":"Shape_circle__uWXEE","triangle":"Shape_triangle__a2WxF","cross":"Shape_cross__b1bsP","star":"Shape_star__kDpQc"};